import { render, staticRenderFns } from "./template.vue?vue&type=template&id=cf043664&scoped=true"
var script = {}
import style0 from "./template.vue?vue&type=style&index=0&id=cf043664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf043664",
  null
  
)

export default component.exports